import useDiscard from "../../../useDiscard";
import useMap from "../../../utils/useMap";

const store = useMap();

window['storePath'] = store;

/**
 * 
 * @param {string} chainId 
 * @param {PropArray | string} paths 
 * @returns {typeof Proxy}
 */
const useLayerQueryByPath = (chainId, paths) => {
    const pathString = typeof paths === 'string' ? paths : paths.pathToString();
    if (!store.has(chainId)) return;
    return store.get(chainId).get(pathString);
}

const onDiscardLayer = (layer,orginalSource) => {

}

/**
 * 
 * @param {PropArray} propPaths 
 * @param {*} layer 
 * @param {*} originalSource 
 */
export const storeByPath = (chainId, propPaths, layer) => {
    if (!store.has(chainId)) {
        store.set(chainId, new Map());
    }

    const pathString = propPaths.pathToString();
    store.get(chainId).set(pathString, layer);

    return () => {
        if (!store.has(chainId)) return;
        store.get(chainId).delete(pathString)
    };
}

export const deleteByChainId = (chainId) => store.delete(chainId);

export const checkHasLayerByPath = (chainId, propPaths) => !!useLayerQueryByPath(chainId, propPaths)

export const countPath = (chainId) => !store.has(chainId) ? 0 : store.get(chainId).size;

export const queryAllLayers = (chainId) => {
    const layers = store.get(chainId);
    if (!layers) return;
    const layerCollection = new Set();
    layers.forEach((layer) => {
        // console.log("item",item)
        layerCollection.add(layer);
    })
    return layerCollection;
};

export const queryAllLayersAsArray = (chainId) => {
    const layers = queryAllLayers(chainId);
    return layers ? Array.from(layers) : []
}

export default useLayerQueryByPath